<script lang="ts" setup>
import { MergeContact, MergePreviewSide } from "~/types/profile";

defineProps<{
  side: MergePreviewSide;
  badge: string;
  badgeType: "success" | "danger" | "primary";
}>();

const defaultAvatar = "/images/avatar.png";

const CONTACT_GROUPS: {
  key: "phones" | "emails" | "addresses";
  label: string;
}[] = [
  { key: "phones", label: "Phones" },
  { key: "emails", label: "Emails" },
  { key: "addresses", label: "Addresses" },
];

const isIncoming = (contact: MergeContact) => contact.incoming === true;
</script>

<template>
  <div
    class="flex flex-col gap-3 rounded-lg border border-gray-200 p-4 dark:border-gray-700"
  >
    <div class="flex items-center gap-3">
      <el-image
        class="h-14 w-14 shrink-0 rounded-full"
        :src="side.profile_picture_url || defaultAvatar"
        :preview-src-list="
          side.profile_picture_url ? [side.profile_picture_url] : []
        "
        :preview-teleported="true"
        :hide-on-click-modal="true"
        fit="cover"
      />
      <div class="flex min-w-0 flex-col gap-1">
        <span class="truncate font-medium">
          {{ side.id }} - {{ side.name || "(no name)" }}
        </span>
        <div class="flex items-center gap-2">
          <el-tag :type="badgeType" size="small" disable-transitions>
            {{ badge }}
          </el-tag>
          <span class="text-xs text-gray-500">
            {{ side.related_total }} related
            {{ side.related_total === 1 ? "record" : "records" }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-for="group in CONTACT_GROUPS"
      :key="group.key"
      class="flex flex-col gap-1"
    >
      <span class="text-xs font-medium uppercase text-gray-400">
        {{ group.label }}
      </span>
      <div v-if="side[group.key].length" class="flex flex-col gap-1">
        <div
          v-for="(contact, index) in side[group.key]"
          :key="`${group.key}-${index}`"
          class="flex items-start gap-2 text-sm"
        >
          <span
            class="break-all"
            :class="{ 'font-medium': contact.is_default }"
          >
            {{ contact.value }}
          </span>
          <el-tag v-if="contact.is_default" size="small" disable-transitions>
            Default
          </el-tag>
          <el-tag
            v-if="isIncoming(contact)"
            type="success"
            size="small"
            disable-transitions
          >
            Added
          </el-tag>
        </div>
      </div>
      <span v-else class="text-sm text-gray-400">—</span>
    </div>
  </div>
</template>
